import {UploadService, UpscaleResponse} from "./service";


export interface ImageData {
    uuid: string;
    name: string;
    altText: string;
    description: string;
    url: string;
    mimeType: string;
    width: number;
    height: number;
    isLandscape: boolean;
    isPortrait: boolean;
    isSquare:boolean;
    ratio: number;
    fileSize: number;
    caption: string
    isMobileOptimized: boolean;
    isAiOptimizedImage: string;
    source: ImageData;
}

export interface SourceImageData extends ImageData {
    imageDataUrl: string;
}


export class Utilities {

    public static async upscaleImage(file: File, operations: any): Promise<ImageData> {


        let sourceImageData : ImageData = await Utilities.getImageMetaDataFromFile(file);
        let optimizedImage: UpscaleResponse = await UploadService.upscale(file, operations);

        return Utilities.createImageDataFromResponse(optimizedImage, sourceImageData);
    }

    public static async createUpscaledFile(file: File, operations: any): Promise<File> {

        let optimizedImage: UpscaleResponse = await UploadService.upscale(file, operations);

        return Utilities.createImageFileFromUrl(file.name, optimizedImage.data.output.tmp_url, true);
    }


    public static async createUpscaledFiles(files: Array<File>, operations: any): Promise<File[]> {

        let optimizedFiles: Array<File> = [];
        for (let file of files) {

            let optimizedImage: UpscaleResponse = await UploadService.upscale(file, operations);

            console.info(
                '%cClaid Service Enhanced Image',
                'display: inline-block; color: black; background: #00FFFF; padding: 1px 4px; border-radius: 3px;',
                file.name,
                optimizedImage.data.output.tmp_url
            );

            let optimizedFile = await Utilities.createImageFileFromUrl(file.name, optimizedImage.data.output.tmp_url, true);

            optimizedFiles.push(optimizedFile);
        }

        return optimizedFiles;
    }

    public static createImageDataFromResponse(imageData: UpscaleResponse, sourceImage: ImageData): ImageData {

        return {
            uuid: sourceImage.uuid,
            name: sourceImage.name,
            altText: sourceImage.altText,
            description: sourceImage.description,
            url: imageData.data.output.tmp_url,
            mimeType: imageData.data.output.mime,
            width: imageData.data.output.width,
            height: imageData.data.output.height,
            isLandscape: (imageData.data.output.width > imageData.data.output.height),
            isPortrait: (imageData.data.output.width < imageData.data.output.height),
            isSquare: (imageData.data.output.width == imageData.data.output.height),
            ratio: (imageData.data.output.width / imageData.data.output.height),
            fileSize: null,
            caption: sourceImage.name,
            isMobileOptimized: (imageData.data.output.width > imageData.data.output.height),
            isAiOptimizedImage: 'true',
            source: sourceImage
        };
    }

    public static async getImageMetaDataFromFile(file: File): Promise<ImageData> {

        const localUrl: string = URL.createObjectURL(file);

        // reading a file to get height and width
        async function getImageParams(file: File): Promise<{}> {
            return new Promise((resolve, reject): void => {
                var reader: FileReader = new FileReader();

                reader.onload = async (e: any): Promise<void> => {
                    var image: HTMLImageElement = new Image();
                    image.src = e.target.result;

                    // @ts-ignore
                    await image.decode();

                    resolve({ width: image.width, height: image.height});
                }
                reader.readAsDataURL(file);
            })
        }

        // @ts-ignore
        const {width, height} = await getImageParams(file);

        return {
            // @ts-ignore
            uuid: crypto.randomUUID(),
            name: file.name,
            altText: file.name,
            description: file.name,
            url: localUrl,
            mimeType: file.type,
            width: width,
            height: height,
            isLandscape: width > height,
            isPortrait: width < height,
            isSquare: width == height,
            ratio: (width / height),
            fileSize: file.size,
            caption: file.name,
            isMobileOptimized: width > height,
            isAiOptimizedImage: 'false',
            source: null
        };
    }

    public static async createImageFileFromUrl(filename: string, url: string, enhanced = false): Promise<File> {

        const response: Response = await fetch(url);
        const blob: Blob = await response.blob();
        if (enhanced == true) {
            filename = `optimized-with-claid-${filename}`;
        }

        return new File([blob], filename,{type: blob.type})
    }
}


// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/claidai/utilities.ts